import type { ContentCardProps } from '@mdvip/shared/components/blocks/ContentCard';

import type { Recipe } from './useRecipes';

/**
 * Recipe -> ContentCardProps. Deliberately drops calorie/tag fields the backend `Recipe` type has
 * no data for this round — only image/title/description/prepTime surface. `imageSrc` binds
 * directly to the query's `imageUrl`, already a signed URL from the backend field resolver; no
 * client-side blob/SAS handling here.
 */
export function toRecipeCard(recipe: Recipe): ContentCardProps {
  return {
    title: recipe.title,
    description: recipe.description ?? undefined,
    imageSrc: recipe.imageUrl ?? undefined,
    meta: recipe.prepTime ? [{ icon: 'clock', label: recipe.prepTime }] : [],
    href: `/resources/nutrition/recipes/${recipe.id}`,
    // Stays pure: the card renders the saved state, RecipesPage supplies `onSaveChange`.
    savable: true,
    saved: recipe.isBookmarked,
  };
}
